import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import "react-tooltip/dist/react-tooltip.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { Tooltip } from "react-tooltip";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import * as XLSX from "xlsx";
import { Link, useNavigate } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import { useTranslation } from "react-i18next";
// import { AiOutlineDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import axios from "axios";
import { Paginator } from "primereact/paginator";
import Moment from "react-moment";
import { Spinner } from "react-bootstrap";
export default function SenderNameTable() {
  let emptyProduct = {
    id: null,
    name: "",
    image: null,
    description: "",
    category: null,
    price: 0,
    quantity: 0,
    rating: 0,
    inventoryStatus: "INSTOCK",
  };

  const [products, setProducts] = useState(null);
  const [productDialog, setProductDialog] = useState(false);
  const [addNumberInGroup, setAddNumberInGroup] = useState(false);

  const [deleteProductDialog, setDeleteProductDialog] = useState(false);
  const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
  const [product, setProduct] = useState(emptyProduct);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { user } = useSelector((state) => state.auth);
  const [editRow, setEditRow] = useState("");
  const [uploadedExcelData, setUploadedExcelData] = useState([]);

  const [isTopBrand, setIsTopBrand] = useState("");

  const [topBrandCategoryOrder, setTopBrandCategoryOrder] = useState(0);
  const [isTopBrandCategory, setIsTopBrandCategory] = useState();

  const [servicesAndProducts, setServicesAndProducts] = useState(
    editRow?.servicesAndProducts?.split(",") || []
  );
  const [contactDetails, setContactDetails] = useState(
    editRow?.data?.contactDetails?.split(",") || []
  );
  const [t, i18n] = useTranslation();

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  ///////getData////
  const navigate = useNavigate("");
  const [data, setData] = useState([]);
  const getData = async (page) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.get(
        `https://mytinkle.net/CompanyActivation/admin` + "?page=" + page,

        config
      );
      console.log(res.data);
      if (res) {
        setData(res.data);

        setTotalPages(res.total / 10);
      } else {
        console.log(res);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);

      //  setError(true);
    }
  };
  const getDataSearch = async (value, page) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.get(
        `https://mytinkle.net/CompanyActivation/admin` +
          "?page=" +
          page +
          "&&searchField=" +
          value,

        config
      );
      console.log("117" + res);
      if (res) {
        setData(res.data);

        setTotalPages(res.total / 10);
      } else {
        console.log(res);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);

      //  setError(true);
    }
  };

  ///sendData
  const sendData = async (e) => {
    e.preventDefault();
    setName("");
    if (name != "") {
      hideDialog();
    }
    setLoading(true);
    let data = {
      name,
    };
    console.log(data);
    // setLoading(true);
    //  dispatch(adminVerfiy(data));
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.post(
        `https://mytinkle.net/Group/create`,
        data,
        config
      );
      console.log(res);
      if (res.status === 201) {
        //  dispatch(adminVerfiy(data));
        getData();
        // setLoading(false);
        setLoading(false);
        setName("");
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });
      } else {
        console.log(res);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
        life: 3000,
      });
      //  setError(true);
    }
  };

  useEffect(() => {
    getData(currentPage);
  }, [currentPage]);
  const onPageChange = (event) => {
    setCurrentPage(event.page + 1); // Add 1 because PrimeReact Paginator starts indexing from 0
  };
  const [countryName, setCountryName] = useState("");
  const [soundID, setSoundID] = useState("");
  const [senderName, setSenderName] = useState("");
  const [activity, setActivity] = useState("");
  const [facebookLink, setFacebookLink] = useState("");

  const [sortTopBrandOrder, setSortTopBrandOrder] = useState();

  const [websiteLink, setWebsiteLink] = useState("");
  const [commercialRegister, setcommercialRegister] = useState("");
  const [taxId, settaxId] = useState("");
  const [delegation, setdelegation] = useState("");
  const [currentTag, setCurrentTag] = useState("");

  const handleInputChangeTag = (e) => {
    setCurrentTag(e.target.value);
  };
  const handleKeyDown = (e) => {
    console.log(e.key, "e.key");
    if (e.key === " ") {
      console.log("handleKeyDown");
      e.preventDefault();
      if (currentTag.trim() !== "") {
        setServicesAndProducts([...servicesAndProducts, currentTag.trim()]);
        setCurrentTag("");
      }
    }
  };
  const [currentTag_2, setCurrentTag_2] = useState("");

  const handleInputChangeTag_2 = (e) => {
    setCurrentTag_2(e.target.value);
  };

  const handleKeyDown_2 = (e) => {
    console.log(e.key, "e.key");
    if (e.key === " ") {
      console.log("handleKeyDown_2");
      e.preventDefault();
      if (currentTag_2.trim() !== "") {
        setServicesAndProducts([...servicesAndProducts, currentTag_2.trim()]);
        setCurrentTag_2("");
      }
    }
  };

  const handleEdit = async () => {
    console.log(editRow._id);
    console.log(user.token);
    hideDialog();
    setLoading(true);
    setEditRow("");

    // const dataObject = {
    //   "soundId": soundID,
    //   "websiteLink": websiteLink,
    //   "facebookLink": facebookLink,
    //   "activity": activity,
    //   "senderName": senderName,
    //   "countryName": countryName,
    //   "commercialRegister": commercialRegister,
    //   "taxId": taxId,
    //   "delegation": delegation,
    // };
    //
    const dataObject = {
      soundId: soundID || editRow.soundId,
      websiteLink: websiteLink || editRow.websiteLink,
      facebookLink: facebookLink || editRow.facebookLink,

      sortTopBrandOrder:
        Number(sortTopBrandOrder) || Number(editRow.sortTopBrandOrder),
      about: activity || editRow.about,
      senderName: senderName || editRow.senderName,
      countryName: countryName || editRow.country?.countryName,
      topBrandCategoryOrder:
        topBrandCategoryOrder || editRow?.topBrandCategoryOrder,
      commercialRegister: commercialRegister,
      taxId: taxId,
      delegation: delegation,
      // "servicesAndProducts":servicesAndProducts,
      servicesAndProducts:
        servicesAndProducts.length > 0 ? servicesAndProducts.join(",") : null,
      contactDetails:
        contactDetails.length > 0 ? contactDetails.join(",") : null,
      isTopBrand: isTopBrand
        ? isTopBrand === "true"
          ? true
          : false
        : editRow.isTopBrand,

      isTopBrandCategory: isTopBrandCategory
        ? isTopBrandCategory === "true"
          ? true
          : false
        : editRow.isTopBrandCategory,
    };

    try {
      const config = {
        headers: {
          // "Content-Type": "multipart/form-data",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };

      console.log(dataObject);
      const res = await axios.patch(
        `https://mytinkle.net/CompanyActivation/update-by-admin/${editRow.user._id}/${editRow._id}`,
        // formData,
        dataObject,
        config
      );
      console.log(res);
      console.log(dataObject);

      if (res) {
        getData(currentPage);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });
        setLoading(false);
      } else {
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
      //  setError(true);
    }
  };

  const [openBlock, setOpenBlock] = useState("");

  const handleAccept = async (editRow) => {
    console.log(editRow._id);
    console.log(editRow);
    hideDialog();
    setLoading(true);
    console.log(
      `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`
    );

    const data = { activationStatus: "Activated" };

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.patch(
        `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`,
        data,
        config
      );
      console.log(res);
      setEditRow("");
      if (res) {
        getData(currentPage);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });

        setLoading(false);
      } else {
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
      //  setError(true);
    }
  };
  const handlePaid = async (editRow) => {
    console.log(editRow._id);
    console.log(user.token);
    hideDialog();
    setLoading(true);
    setEditRow("");
    console.log(
      `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`
    );

    const data = { activationStatus: "Activated" };

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.patch(
        `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`,
        data,
        config
      );
      console.log(res);
      if (res) {
        getData(currentPage);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });

        setLoading(false);
      } else {
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
      //  setError(true);
    }
  };

  const [comment, setComment] = useState("");
  const handleUnBlock = async (editRow) => {
    console.log(editRow._id);
    console.log(user.token);
    hideDialog();
    setLoading(true);
    setEditRow("");
    console.log(
      `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`
    );

    const data = {
      activationStatus: "Activation Rejected",
      rejectedReasons: comment,
    };
    console.log(data);

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.patch(
        `https://mytinkle.net/CompanyActivation/update-activation-status/${editRow.user._id}/${editRow._id}`,
        data,
        config
      );
      console.log(res);
      setOpenBlock("");
      if (res) {
        getData(currentPage);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });

        setLoading(false);
      } else {
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setOpenBlock("");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error,
        life: 3000,
      });
      //  setError(true);
    }
  };
  const handleDelete = async () => {
    setDeleteProductDialog(false);
    hideDialog();
    setLoading(true);
    setEditRow("");
    setRowDelete("");
    console.log(data);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
      };
      const res = await axios.delete(
        `https://mytinkle.net/CompanyActivation/delete-by-admin/${rowDelete._id}`,
        config,
        config
      );
      console.log(res);
      if (res) {
        getData(currentPage);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.message,
          life: 3000,
        });
      } else {
        console.log(res);
        setLoading(false);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
      setLoading(false);
      //   toast.current.show({
      //     severity: "error",
      //     summary: "Error",
      //     detail: error,
      //     life: 3000,
      //   });
      //  setError(true);
    }
  };

  const downloadcommercialRegister = async (e) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
        responseType: "blob",
      };
      const res = await axios.get(
        `https://mytinkle.net/CompanyActivation/download-commercialRegister/${e.user._id}/${e._id}`,

        config
      );
      console.log(res, "1");
      if (res) {
        //  dispatch(adminVerfiy(data));
        // getData();
        if (res) {
          console.log(res, "asd");
          const blob = new Blob([res], {
            type: res.type,
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "commercialRegister";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      } else {
        console.log(res);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.data.message,
          life: 3000,
        });
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
        life: 3000,
      });
      //  setError(true);
    }

    fetch(`https://mytinkle.net/Group/export-selected-group`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(array),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          console.log(response.json());
        }
        return response.blob();
      })
      .then((data) => {
        if (data) {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Groups.xlsx";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const downloadtaxId = async (e) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
        responseType: "blob",
      };
      const res = await axios.get(
        `https://mytinkle.net/CompanyActivation/download-taxId/${e.user._id}/${e._id}`,

        config
      );
      console.log(res, "1");
      if (res) {
        //  dispatch(adminVerfiy(data));
        // getData();
        if (res) {
          console.log(res, "asd");
          const blob = new Blob([res], {
            type: res.type,
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "commercialRegister";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      } else {
        console.log(res);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.data.message,
          life: 3000,
        });
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
        life: 3000,
      });
      //  setError(true);
    }

    fetch(`https://mytinkle.net/Group/export-selected-group`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(array),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          console.log(response.json());
        }
        return response.blob();
      })
      .then((data) => {
        if (data) {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Groups.xlsx";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const downloaddelegation = async (e) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          withCredentials: false,
          Authorization: `Bearer ${user.token}`,
        },
        responseType: "blob",
      };
      const res = await axios.get(
        `https://mytinkle.net/CompanyActivation/download-logo /${e.user._id}/${e._id}`,

        config
      );
      console.log(res, "1");
      if (res) {
        //  dispatch(adminVerfiy(data));
        // getData();
        if (res) {
          console.log(res, "asd");
          const blob = new Blob([res], {
            type: res.type,
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "commercialRegister";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      } else {
        console.log(res);
        setLoading(false);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: res.data.message,
          life: 3000,
        });
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
      console.log(error);
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
        life: 3000,
      });
      //  setError(true);
    }

    fetch(`https://mytinkle.net/Group/export-selected-group`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      body: JSON.stringify(array),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          console.log(response.json());
        }
        return response.blob();
      })
      .then((data) => {
        if (data) {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Groups.xlsx";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///////////

  const openNew = () => {
    setProduct(emptyProduct);
    setSubmitted(false);
    setProductDialog(true);
  };

  const hideDialog = () => {
    setEditRow("");
    setSubmitted(false);
    setProductDialog(false);
  };
  const handleAddOneInGrroup = () => {
    setAddNumberInGroup(true);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProductsDialog(false);
  };

  const editProduct = (product) => {
    console.log("lolo", product);
    setEditRow(product);
    setServicesAndProducts(product?.servicesAndProducts?.split(","));
    setContactDetails(product?.contactDetails?.split(","));
    setProductDialog(true);
  };

  // const editProduct = (product) => {
  //   setEditRow(product);
  //   setServicesAndProducts(product?.servicesAndProducts?.split(",") || []);
  //   setContactDetails(product?.contactDetails?.split(",") || []);
  //   setProductDialog(true);
  // };

  const [rowDelete, setRowDelete] = useState("");

  const confirmDeleteProduct = (product) => {
    setRowDelete(product);
    setDeleteProductDialog(true);
  };

  const confirmDeleteSelected = () => {
    setDeleteProductsDialog(true);
  };

  const deleteSelectedProducts = () => {
    let _products = products.filter((val) => !selectedProducts.includes(val));

    setProducts(_products);
    setDeleteProductsDialog(false);
    setSelectedProducts(null);
    toast.current.show({
      severity: "success",
      summary: "Successful",
      detail: "Products Deleted",
      life: 3000,
    });
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between col-12">
      <span className="p-input-icon-left col-12 col-md-6">
        <i className="pi pi-search" />
        <div class="form-floating mb-4">
          <input
            id="textInputExample"
            type="search"
            onInput={(e) => {
              setCurrentPage(1);
              setGlobalFilter(e.target.value);

              getDataSearch(e.target.value, currentPage);
            }}
            placeholder="Search..."
            class="form-control"
          />
          <label for="textInputExample">{t("Search...")}</label>
        </div>
      </span>
    </div>
  );

  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  const nameBodyTemplate = (rowData) => {
    return (
      <Link to={`/smspro-groups_grid/${rowData.group._id}`}>
        {rowData.group.name}
      </Link>
    );
  };

  const handleToggleChange = (rowData, value) => {
    setCheckedRows((prevCheckedRows) => ({
      ...prevCheckedRows,
      [rowData._id]: value,
    }));
  };

  const statusBodyTemplate2 = (rowData) => {
    return (
      <>
        {/* {rowData.activationStatus == "Activation in progress" && ( */}
        {/* <div className="d-flex gap-2">
          {rowData?.activationStatus != "Activated" && (
            <>
              <button
                label="New"
                icon="pi pi-plus"
                severity="success"
                className="btn btn-success rounded-xl mx-1 fs-14 "
                onClick={() => handleAccept(rowData)}
              >
                Accept
              </button>
            </>
          )}
          <button
            label="New"
            icon="pi pi-plus"
            severity="success"
            className="btn btn-danger rounded-xl mx-1 fs-14 "
            onClick={() => setOpenBlock(rowData)}
          >
            Block
          </button>
        </div> */}
        <InputSwitch
          checked={rowData.activationStatus == "Activated" || false}
          onChange={(e) => {
            if (rowData.activationStatus == "Activated") {
              setOpenBlock(rowData);
            } else {
              handleAccept(rowData);
            }
            // handleToggleChange(rowData, e.value);
          }}
        />
        {/* )} */}
      </>

      // <InputSwitch
      //   checked={checkedRows[rowData._id] || false}
      //   onChange={(e) => handleToggleChange(rowData, e.value)}
      // />
    );
  };

  const [checkedRows, setCheckedRows] = useState({});

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <div className="d-flex gap-2 align-items-center">
          <i
            class="uil uil-edit fs-17 text-blue cursor-pointer"
            icon="pi pi-pencil mr-2"
            onClick={() => {
              editProduct(rowData);
            }}
          ></i>

          <div className="d-flex gap-2">
            <Button
              className=" bg-danger py-1 px-2"
              onClick={() => confirmDeleteProduct(rowData)}
            >
              <i className="ri-delete-bin-2-line bg-danger"></i>
            </Button>
          </div>

          <i class="uil uil-copy  fs-17 text-green cursor-pointer"></i>

          <i
            class="uil uil-plus-circle fs-17 text-green cursor-pointer"
            onClick={handleAddOneInGrroup}
          ></i>
        </div>
      </React.Fragment>
    );
  };

  const actionEdit = (rowData) => {
    return (
      <React.Fragment>
        <div className="d-flex gap-2">
          <Button
            className=" bg-gradient	 py-1 px-2"
            onClick={() => editProduct(rowData)}
          >
            <i className=" ri-edit-box-line text-info-emphasis cursor-pointe"></i>
          </Button>
        </div>
      </React.Fragment>
    );
  };

  //delete
  const [userName, setUser] = useState("");
  return (
    <div>
      <Toast ref={toast} />

      <div className="card-body">
        {/* <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar> */}

        <DataTable
          width={"100%"}
          ref={dt}
          value={data}
          selection={selectedProducts}
          onSelectionChange={(e) => setSelectedProducts(e.value)}
          // dataKey="id"
          rows={10}
          header={header}
          // selectionMode={"checkbox"}
          totalRecords={20}
        >
          {/* <Column selectionMode="multiple" exportable={false}></Column> */}
          <Column
            header="ID"
            style={{ width: "8rem" }}
            body={(rowData) => {
              return <div>{rowData.code}</div>;
            }}
            className="fs-14 "
          />
          <Column
            className="fs-13"
            // body={nameBodyTemplate}
            field="soundId"
            header="Sound"
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            className="fs-13"
            // body={nameBodyTemplate}
            field="senderName"
            header="Sender Name"
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            className="fs-13"
            // body={nameBodyTemplate}
            body={(rowData) => {
              return (
                <React.Fragment>
                  <div
                    className="d-flex align-items-center gap-2 cursor-pointer"
                    style={{ cursor: "pointer" }}
                    onClick={() => setUser(rowData.user)}
                  >
                    {rowData?.user?.firstName}
                  </div>
                </React.Fragment>
              );
            }}
            header="Client Name"
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            className="fs-13"
            // body={nameBodyTemplate}
            field="paymentMethod"
            header="payment Method"
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            className="fs-13"
            header="Country"
            body={(rowData) => {
              return (
                <React.Fragment>
                  <div className="d-flex align-items-center gap-2">
                    {rowData?.country?.countryName.en}
                  </div>
                </React.Fragment>
              );
            }}
            style={{ minWidth: "4rem" }}
          ></Column>
          <Column
            className="fs-13"
            field="activationStatus"
            body={(rowData) => {
              return (
                <>
                  {rowData.activationStatus == "Activation in progress" ? (
                    <div className="text-blue d-flex align-items-center gap-1">
                      <span
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: "blue",
                          display: "block",
                          minWidth: "10px",
                        }}
                      ></span>{" "}
                      {rowData.activationStatus}
                    </div>
                  ) : rowData.activationStatus == "Activated" ? (
                    <div className="text-green d-flex align-items-center gap-1">
                      <span
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: "green",
                          display: "block",
                          minWidth: "10px",
                        }}
                      ></span>{" "}
                      {rowData.activationStatus}
                    </div>
                  ) : (
                    <div className="text-danger d-flex align-items-center gap-1">
                      {" "}
                      <span
                        className="my-anchor-element"
                        id="my-anchor-element"
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: "red",
                          display: "block",
                        }}
                      ></span>{" "}
                      {rowData.activationStatus}
                      <Tooltip anchorSelect=".my-anchor-element" place="top">
                        {rowData?.rejectedReasons}
                      </Tooltip>{" "}
                    </div>
                  )}
                </>
              );
            }}
            header="Status"
            style={{ minWidth: "4rem" }}
          ></Column>
          <Column
            className="fs-13"
            field="isPaid"
            header="Payment"
            style={{ minWidth: "4rem" }}
          ></Column>

          {/* <Column
            className="fs-13 w100"
            body={(rowData) => {
              return (
                
              );
            }}
            header="Commercial Register"
            style={{ minWidth: "10rem" }}
          ></Column> */}
          {/* <Column
            className="fs-13"
            body={(rowData) => {
              return (
               
              );
            }}
            header="taxId"
            style={{ minWidth: "4rem" }}
          ></Column> */}
          {/* <Column
            className="fs-13"
            body={(rowData) => {
              return (
               
              );
            }}
            header="Delegation"
            style={{ minWidth: "4rem" }}
          ></Column> */}

          <Column
            className="fs-13"
            body={(rowData) => {
              return (
                <React.Fragment>
                  <div className="d-flex align-items-center gap-2">
                    <Moment
                      format="YYYY/MM/DD"
                      date={rowData.createdAt}
                      style={{ marginTop: "-10px" }}
                    />{" "}
                  </div>
                </React.Fragment>
              );
            }}
            header={t("Date")}
            style={{ minWidth: "2rem" }}
          ></Column>

          <Column
            className="fs-13"
            header="Edit"
            body={actionEdit}
            exportable={false}
            // style={{ minWidth: "8rem" }}
          ></Column>
          <Column
            className="fs-13"
            header="Actions"
            body={actionBodyTemplate}
            exportable={false}
          ></Column>
        </DataTable>
      </div>
      <Paginator
        first={currentPage * 10 - 10} // Adjust the '10' to match the number of items per page
        rows={10} // Set the number of items per page
        totalRecords={totalPages * 10} // Assuming there are 10 items per page, and 'totalPages' is the total number of pages
        onPageChange={onPageChange}
      />

      <Dialog
        visible={productDialog}
        style={{ width: "45rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={editRow?.senderName ? t("Edit Sender Name") : t("Sender Name")}
        modal
        className="p-fluid"
        footer={
          <React.Fragment>
            <Button
              label="Cancels"
              icon="pi pi-times"
              outlined
              onClick={hideDialog}
            />
            <Button
              label="Save"
              icon="pi pi-check"
              type="submit"
              onClick={(e) =>
                editRow?.senderName ? handleEdit() : sendData(e)
              }
            />
          </React.Fragment>
        }
        onHide={hideDialog}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendData();
          }}
        >
          <div class="card-body">
            <div className="d-flex align-items-center  justify-content-between w-100 mb-4">
              <div class="form-select-wrapper  d-md-block d-none">
                <label className="text-orange ">{t("Status")}</label>
              </div>
              <div class="form-floating  ">
                <div className="d-flex gap-2">
                  <button
                    label="New"
                    icon="pi pi-plus"
                    type="button"
                    severity="success"
                    className="btn btn-success rounded-xl mx-1 fs-14 "
                    onClick={() => handleAccept(editRow)}
                  >
                    Accept
                  </button>

                  <button
                    label="New"
                    icon="pi pi-plus"
                    type="button"
                    severity="success"
                    className="btn btn-danger rounded-xl mx-1 fs-14 "
                    onClick={() => setOpenBlock(editRow)}
                  >
                    Block
                  </button>
                </div>
                {/* <InputSwitch
                  checked={editRow.activationStatus == "Activated" || false}
                  onChange={(e) => {
                    if (editRow.activationStatus == "Activated") {
                      setOpenBlock(editRow);
                    } else {
                      handleAccept(editRow);
                    }
                    // handleToggleChange(rowData, e.value);
                  }}
                /> */}
              </div>
            </div>
            <div className="d-flex align-items-center  justify-content-between w-100 mb-4">
              <div class="form-select-wrapper  d-md-block d-none">
                <label className="text-orange ">{t("Paid")}</label>
              </div>
              <div class="form-floating  ">
                <InputSwitch
                  checked={editRow.activationStatus == "Activated" || false}
                  onChange={(e) => {
                    if (editRow.activationStatus == "Activated") {
                      setOpenBlock(editRow);
                    } else {
                      handleAccept(editRow);
                    }
                    // handleToggleChange(rowData, e.value);
                  }}
                />
              </div>
            </div>
            {/* //////////////////////////////////////////////////// */}
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange">{t("Sound ID")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    id="textInputExample"
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                    // defaultValue={editRow.soundID}
                    defaultValue={editRow.soundId}
                    onChange={(e) => setSoundID(e.target.value)}
                    required
                  />
                  <label for="textInputExample">{t("Sound ID")}</label>
                </div>
              </div>
            </div>
            {/* ///////////////////////////////////////////////////////////////////// */}
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">{t("Select Country")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <div className="form-select-wrapper">
                    <select
                      className="form-select"
                      required
                      aria-label="Default select example"
                      onChange={(e) => setCountryName(e.target.value)}
                      defaultValue={editRow?.country?.countryName}
                    >
                      <option selected> {t("Select Country")}</option>
                      <option value={"Egypt"}>Egypt </option>
                      <option value={"Saudi Arabia"}>Saudi</option>
                      <option value={"United Arab Emirates"}> </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">{t("Sender Name")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    id="textInputExample"
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                    defaultValue={editRow.senderName}
                    onChange={(e) => setSenderName(e.target.value)}
                    required
                  />
                  <label for="textInputExample">{t("Sender Name")}</label>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange "> {t("About")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <textarea
                    onChange={(e) => setActivity(e.target.value)}
                    required
                    id="textInputExample"
                    defaultValue={editRow.about}
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                  />
                  <label for="textInputExample">{t("About")}</label>
                </div>
              </div>
            </div>{" "}
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-3 d-md-block d-none">
                <label className="text-orange ">
                  {" "}
                  {t("servicesAndProducts")}
                </label>
              </div>
              <div class="form-floating  col-md-9  col-12">
                <div class="form-floating ">
                  {/* {console.log(editRow, "editRow")} */}
                  <TagsInput
                    value={servicesAndProducts}
                    onChange={(e) => setServicesAndProducts(e)}
                    onChangeInput={handleInputChangeTag}
                    addKeys={[13, 9, 188]}
                    maxTags={10}
                  />
                  {/* <textarea
                    onChange={(e) => setActivity(e.target.value)}
                    required
                    id="textInputExample"
                    defaultValue={editRow.servicesAndProducts}
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                  /> */}
                  {/* <label for="textInputExample">
                    {t("servicesAndProducts")}
                  </label> */}
                </div>
              </div>
            </div>{" "}
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-3 d-md-block d-none">
                <label className="text-orange "> {t("Contact Details")}</label>
              </div>
              <div class="form-floating  col-md-9  col-12">
                <div class="form-floating ">
                  {/* <textarea
                    onChange={(e) => setActivity(e.target.value)}
                    required
                    id="textInputExample"
                    defaultValue={editRow.contactDetails}
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                  /> */}
                  <TagsInput
                    value={contactDetails}
                    onChange={(e) => setContactDetails(e)}
                    onChangeInput={handleInputChangeTag_2}
                    addKeys={[13, 9, 188]}
                    maxTags={10}
                  />
                  {/* <label for="textInputExample">{t("ContactDetails")}</label> */}
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">Category Name</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    id="category"
                    defaultValue={editRow?.category?.name?.en}
                    type="text"
                    className="form-control"
                    placeholder="Text Input"
                    readOnly
                  />

                  <label for="category">Category Name</label>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">Sort Top Brand Order</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    onChange={(e) => setSortTopBrandOrder(e.target.value)}
                    id="sortTopBrandOrder"
                    defaultValue={editRow.sortTopBrandOrder}
                    type="number"
                    class="form-control"
                    placeholder="Text Input"
                  />
                  <label for="sortTopBrandOrder">Sort Top Brand Order</label>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <label htmlFor="description" className="font-bold col-2">
                Is Top Brand
              </label>
              <div class="form-floating mb-4 col-md-10  col-12">
                <select
                  class="form-select pt-1 "
                  aria-label="Default select example"
                  defaultValue={editRow.isTopBrand}
                  onChange={(e) => setIsTopBrand(e.target.value)}
                >
                  <option selected>Is Top Brand</option>
                  <option value="true">true</option>
                  <option value="false">false</option>
                </select>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">top Brand Category Order</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    onChange={(e) =>
                      setTopBrandCategoryOrder(Number(e.target.value))
                    }
                    id="topBrandCategoryOrder"
                    defaultValue={editRow.topBrandCategoryOrder}
                    type="number"
                    className="form-control"
                    placeholder="Text Input"
                  />

                  <label for="topBrandCategoryOrder">top Brand</label>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <label htmlFor="description" className="font-bold col-2">
                is Top Brand Category
              </label>
              <div class="form-floating mb-4 col-md-10  col-12">
                <select
                  className="form-select pt-1 "
                  aria-label="Default select example"
                  defaultValue={editRow.isTopBrandCategory}
                  onChange={(e) => setIsTopBrandCategory(e.target.value)}
                >
                  <option selected>Is Top Brand Category</option>
                  <option value="true">true</option>
                  <option value="false">false</option>
                </select>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange ">{t("Facebook Link")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    onChange={(e) => setFacebookLink(e.target.value)}
                    id="textInputExample"
                    defaultValue={editRow.facebookLink}
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                  />
                  <label for="textInputExample">{t("Facebook Link")}</label>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div class="form-select-wrapper  col-2 d-md-block d-none">
                <label className="text-orange "> {t("Website Link")}</label>
              </div>
              <div class="form-floating  col-md-10  col-12">
                <div class="form-floating ">
                  <input
                    onChange={(e) => setWebsiteLink(e.target.value)}
                    id="textInputExample"
                    defaultValue={editRow.websiteLink}
                    type="text"
                    class="form-control"
                    placeholder="Text Input"
                  />
                  <label for="textInputExample">{t("Website Link")}</label>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center mb-4">
                <div class="form-select-wrapper  col-4 d-md-block ">
                  <label className="text-orange ">
                    {t("Commercial register")}
                  </label>
                </div>
                <div className=" col-md-4  col-6 d-flex  justify-content-end">
                  <React.Fragment>
                    {editRow?.commercialRegister?.length > 0 ? (
                      <div className="d-flex gap-2">
                        <Button
                          type="button"
                          className=" bg-gradient	 py-1 px-2"
                          onClick={() => downloadcommercialRegister(editRow)}
                        >
                          <i className=" ri-chat-download-fill text-info-emphasis cursor-pointe"></i>
                        </Button>
                      </div>
                    ) : (
                      "Not Found"
                    )}
                  </React.Fragment>
                </div>
                <input
                  onChange={(e) => setcommercialRegister(e.target.files[0])}
                  id="register"
                  type="file"
                  accept=".pdf ,.png,.jpg, .xls"
                  style={{ display: "none" }}
                  //   onChange={handleUploadExcel}
                />
              </div>
              <div className="d-flex align-items-center mb-4">
                <div class="form-select-wrapper mb-4 col-4  d-md-block ">
                  <label className="text-orange ">{t("Tax id")}</label>
                </div>
                <div className="mb-4 col-md-4  col-6 d-flex  justify-content-end">
                  <React.Fragment>
                    {editRow?.taxId?.length > 0 ? (
                      <div className="d-flex gap-2">
                        <Button
                          type="button"
                          className=" bg-gradient	 py-1 px-2"
                          onClick={() => downloadtaxId(editRow)}
                        >
                          <i className=" ri-chat-download-fill text-info-emphasis cursor-pointe"></i>
                        </Button>
                      </div>
                    ) : (
                      "Not Found"
                    )}
                  </React.Fragment>
                </div>
                <input
                  onChange={(e) => settaxId(e.target.files[0])}
                  id="tax"
                  type="file"
                  accept=".pdf ,.png,.jpg, .xls"
                  style={{ display: "none" }}
                  //   onChange={handleUploadExcel}
                />
              </div>
              <div className="d-flex align-items-center mb-4mb-4">
                <div class="form-select-wrapper mb-4 col-4  d-md-block">
                  <label className="text-orange ">{t("Logo")}</label>
                </div>
                <div className="mb-4 col-md-4  col-6 d-flex  justify-content-end">
                  <React.Fragment>
                    {editRow?.logo ? (
                      <img
                        src={editRow?.logo}
                        style={{ width: "100px", height: "100%" }}
                      />
                    ) : (
                      // <div className="d-flex gap-2">
                      //   <Button
                      //     type="button"
                      //     className=" bg-gradient	 py-1 px-2"
                      //     onClick={() => downloaddelegation(editRow)}
                      //   >
                      //     <i className=" ri-chat-download-fill text-info-emphasis cursor-pointe"></i>
                      //   </Button>
                      // </div>
                      "Not Found"
                    )}
                  </React.Fragment>
                </div>
                <input
                  onChange={(e) => setdelegation(e.target.files[0])}
                  id="Delegation"
                  type="file"
                  accept=".pdf ,.png,.jpg, .xls"
                  style={{ display: "none" }}
                  //   onChange={handleUploadExcel}
                />
              </div>

              {/* <div class="form-check my-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  {" "}
                  {t("Default checkbox")}
                </label>
              </div> */}
            </div>
          </div>
        </form>
      </Dialog>
      <Dialog
        visible={openBlock}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header={editRow.name ? t(" Rejected Reason") : t(" Rejected Reason")}
        modal
        className="p-fluid"
        footer={
          <React.Fragment>
            <Button
              label="Cancels"
              icon="pi pi-times"
              outlined
              onClick={() => setOpenBlock("")}
            />
            <Button
              label="Save"
              icon="pi pi-check"
              onClick={() => handleUnBlock(openBlock)}
            />
          </React.Fragment>
        }
        onHide={() => setOpenBlock("")}
      >
        <div className="field">
          <label htmlFor="comment" className="font-bold">
            Comment
          </label>
          <InputText
            id="comment"
            onChange={(e) => setComment(e.target.value)}
            required
            //   autoFocus
            defaultValue={name}
            autoFocus
          />
        </div>
      </Dialog>

      <Dialog
        visible={deleteProductDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={
          <React.Fragment>
            <Button
              label="No"
              icon="pi pi-times"
              outlined
              onClick={hideDeleteProductDialog}
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              severity="danger"
              onClick={() => handleDelete()}
            />
          </React.Fragment>
        }
        onHide={hideDeleteProductDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {product && (
            <span>
              {t("Are you sure you want to delete ")}
              <b>{rowDelete?.senderName}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteProductsDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteProductsDialogFooter}
        onHide={hideDeleteProductsDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {product && (
            <span>
              {t("Are you sure you want to delete the selected products?")}
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={userName}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Information"
        modal
        // footer={deleteProductsDialogFooter}
        onHide={() => setUser("")}
      >
        <div className="d-flex align-items-center  justify-content-between w-100 mb-4">
          <div class="form-select-wrapper  d-md-block d-none">
            <label className="text-orange ">{t("Name")}</label>
          </div>
          <div class="form-floating  ">{userName.firstName}</div>
        </div>
        <div className="d-flex align-items-center  justify-content-between w-100 mb-4">
          <div class="form-select-wrapper  d-md-block d-none">
            <label className="text-orange ">{t("Email")}</label>
          </div>
          <div class="form-floating  ">{userName.email}</div>
        </div>
        <div className="d-flex align-items-center  justify-content-between w-100 mb-4">
          <div class="form-select-wrapper  d-md-block d-none">
            <label className="text-orange ">{t("Phone")}</label>
          </div>
          <div class="form-floating  ">{userName.phoneNumber}</div>
        </div>
      </Dialog>
    </div>
  );
}
